(function ($) {
	'use strict';

	/**
	 * All of the code for your admin-facing JavaScript source
	 * should reside in this file.
	 *
	 * Note: It has been assumed you will write jQuery code here, so the
	 * $ function reference has been prepared for usage within the scope
	 * of this function.
	 *
	 * This enables you to define handlers, for when the DOM is ready:
	 *
	 * $(function() {
	 *
	 * });
	 *
	 * When the window is loaded:
	 *
	 * $( window ).load(function() {
	 *
	 * });
	 *
	 * ...and/or other possibilities.
	 *
	 * Ideally, it is not considered best practise to attach more than a
	 * single DOM-ready or window-load handler for a particular page.
	 * Although scripts in the WordPress core, Plugins and Themes may be
	 * practising this, we should strive to set a better example in our own work.
	 */
	$.hillphoenix = $.hillphoenix || {};

	$(document).ready(function () {
		$.hillphoenix.init();
	});

	$.hillphoenix.init = function () {
		$.hillphoenix.productListSorting();
		$.hillphoenix.searchProduct();
		$.hillphoenix.handleResourceTab();
		$.hillphoenix.addToDownloadList();
		$.hillphoenix.showDownloadList();
		$.hillphoenix.fillCountsInitially();
		$.hillphoenix.closeDownloadPopup();
		$.hillphoenix.removeFromDownloadList();
		$.hillphoenix.addAllToDownloadList();
		$.hillphoenix.downloadResource();
		$.hillphoenix.clearDownloads();
		$.hillphoenix.accordion();
		$.hillphoenix.toggleProductDescription();
		$.hillphoenix.initSlider();
		$.hillphoenix.toggleFilterArea();
		$.hillphoenix.selectProductPageOptions();
		$.hillphoenix.addToCompare();
		$.hillphoenix.compareModal();
		$.hillphoenix.removeFromCompare();
		$.hillphoenix.filterProductAttributes();
		$.hillphoenix.openFancyBox();
		$.hillphoenix.downloadSlideItem();
		$.hillphoenix.showCurrentSlideName();
		$.hillphoenix.downloadAll();
		$.hillphoenix.quickViewModal();
		$.hillphoenix.closeModal();
		$.hillphoenix.infiniteScroll();
		$.hillphoenix.filterProductCategories();
		$.hillphoenix.hoverPreview();
		$.hillphoenix.relatedProducts();
		$.hillphoenix.globalSearch();
		$.hillphoenix.handleResourceList();
		$.hillphoenix.handleResourceSearch();
		$.hillphoenix.galleryPopup();
		$.hillphoenix.initO3dv();
		$.hillphoenix.ShowcaseSidebar();
		$.hillphoenix.FilterResourcesList();
		$.hillphoenix.getResourcesList();
	};
	$.hillphoenix.getResourcesList = function(){
		$(document).on("change",".hp-variations-sort", function() {
			var field = $(this),
                container = field.next();
                //container = $("#proResources");
			//container.fadeOut();
			container.html('<span class="loader"></span>').fadeIn();
			$.ajax({
				type: 'POST',
				url: hillphoenixJs.ajax_url,
				data: {
					product_slug: field.val(),
					action: 'hillphoenix_get_products_resources_by_slug'
				},
				beforeSend: function () {
					//.addClass('hp-is-loading')
				},
				success: function (r) {
					var response = JSON.parse(r);
					if (response.status.toString() === 'success') {
						if (response.data.length) {
							container.html(response.data).fadeIn();
						} else {
							container.html('<div class="hp-empty-message">No result found</div>').fadeIn();
						}
					} else {
						container.html('<div class="hp-empty-message">No result found</div>').fadeIn();
					}
				},
				error: function (e) {
					console.log(e);
				},
				complete: function () {
					//.removeClass('hp-is-loading')
				}
			})
		});
		/*$(".hp-variations-sort").each(function() {
			$(this).trigger("change");
		});*/
	}

	$.hillphoenix.FilterResourcesList = function(){
		$("#filterResources").on("keyup", function() {
			var value = $(this).val().toLowerCase();
			$("#hp-resources-item-list .hp-resource-list-item").filter(function() {
			$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
			});
	});
	}

	$.hillphoenix.ShowcaseSidebar = function () {
		$("#hp-showcase-list li a").on('click', function (e) {
			if ($(this).next(".sub-dropdown").length != 0) {
				e.preventDefault();
				if ($(this).find('i').hasClass('icon-plus-alt')) {
					$(this).find('i').removeClass('icon-plus-alt');
					$(this).find('i').addClass('icon-minus-alt');
				} else {
					$(this).find('i').removeClass('icon-minus-alt');
					$(this).find('i').addClass('icon-plus-alt');
				}
				$(this).next(".sub-dropdown").slideToggle();
			}
		});
	}

	$.hillphoenix.productListSorting = function () {
		$('.hp-product-sort').on('change', function () {
			var select = $(this),
				sort_args = getSortArgs();
			if (sort_args[select.val()]) {
				redirectWithNewQuery(buildQueryParams([
					{
						key: 'h_page',
						value: 1
					},
					{
						key: 'h_sort',
						value: sort_args[select.val()].h_sort
					},
					{
						key: 'h_sort_by',
						value: sort_args[select.val()].h_sort_by
					}
				]));
			}
		})
	};

	$.hillphoenix.searchProduct = function () {
		var typingTimer;
		var searchBox = $('.hp-search input');
		searchBox.on('keyup', function () {
			var field = $(this);
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function () {
				getSearchResult(field);
			}, 500);
		});
		searchBox.on('keydown', function () {
			clearTimeout(typingTimer);
		});
		$('.hp-clear-search').on('click', function (e) {
			e.preventDefault();
			var search_container = $(this).parents('.search-inner'),
				wrapper = $(this).parents('.hp-search');
			wrapper.find('input').val('');
			search_container.find('.hp-search-results').html('').fadeOut();
			wrapper.removeClass('hp-has-search');
		})

		function getSearchResult(field) {
			var search_container = field.parents('.search-inner'),
				wrapper = field.parents('.hp-search'),
				text = field.val(),
				nonce = wrapper.data('nonce'),
				categories = $('.filter-item.type-category input[type="checkbox"]:checked'),
				requestData = {
					text: text,
					nonce: nonce,
					action: 'hillphoenix_search_product_list'
				};

			var excludeWpPosts = wrapper.find('.exclude_wp_posts').val();
			if (typeof excludeWpPosts !== 'undefined') {
				requestData.exclude_wp_posts = excludeWpPosts;
			}
			wrapper.addClass('hp-searching hp-has-search');
			search_container.find('.hp-search-results').html('<span class="loader"></span>').fadeIn();
			if (categories.length) {
				var selected = '';
				$.each(categories, function (i, category) {
					selected += $(category).val() + ',';
				});
				requestData.categories = rtrim(selected, ',');
			}
			$.ajax({
				type: 'POST',
				url: hillphoenixJs.ajax_url,
				data: requestData,
				success: function (r) {
					var response = JSON.parse(r);
					if (response.status.toString() === 'success') {
						if (response.data.length) {
							search_container.find('.hp-search-results').html(getSearchResultsHtml(response.data)).fadeIn();
							//wrapper.find('.hp-search-results').html(getSearchHtml(response.data)).fadeIn();
						} else {
							search_container.find('.hp-search-results').html('<p class="hp-empty-result">No results found</p>').fadeIn();
						}
					} else {
						search_container.find('.hp-search-results').html('<p class="hp-empty-result">' + response.message + '</p>').fadeIn();
					}

					//search_resource search all resource and add resources under products search result 
					/* resouces search change to product base	$.ajax({
								type: 'POST',
								url: hillphoenixJs.ajax_url,
								data: {
									search: text,
									nonce: nonce,
									action: 'hillphoenix_search_resource'
								},
								success: function (r) {
									var response = JSON.parse(r);
								
									if (response.status.toString() === 'success') {
										if (response.data.length) {
											let $tb_rs1_content = '.hp-search-results .tab-content';
											search_container.find('.hp-search-results .tab-nav ul').append('<li><a href="#resources" data-hp-tab="resources1">Product Resources</a></li>');
											search_container.find($tb_rs1_content).append("<div id='resources1' class='tab-item'></div>");
											search_container.find($tb_rs1_content + ' #resources1').append(getResourceSearchResultHtml(response.data));
											search_container.find($tb_rs1_content + ' #taball').append("<div style='border-bottom:1px solid #eee; width:100%;font-weight: bold;text-align: center;padding: 2px 0 2px 0;'>Resources</div>");
											search_container.find($tb_rs1_content + ' #taball').append(getResourceSearchResultHtml(response.data));
											//wrapper.find('.hp-search-results').append("<div style='border-bottom:1px solid #eee; width:100%;font-weight: bold;text-align: center;padding: 2px 0 2px 0;'>Resources</div>");
											//wrapper.find('.hp-search-results').append(getResourceSearchResultHtml(response.data));
											// results.html(getResourceSearchResultHtml(response.data)).fadeIn();
										}
									}
								},
								error: function (e) {
									console.log(e);
								}
							});// end search_resource */

					//resource_centre_search add resources under products result
					$.ajax({
						type: 'POST',
						url: hillphoenixJs.ajax_url,
						data: {
							search: text,
							nonce: nonce,
							action: 'hillphoenix_resource_centre_search'
						},
						success: function (r) {
							var response = JSON.parse(r);
							//console.log(response);
							if (response.status.toString() === 'success') {
								if (response.data.length) {
									getSearchResourcesCenterHtml(search_container, response.data);
								}
							}
						},
						error: function (e) {
							console.log(e);
						}
					});// end resource_centre_search
				},
				error: function (e) {
					console.log(e);
				},
				complete: function () {
					wrapper.removeClass('hp-searching');
				}
			});
		}
		function getSearchResultsHtml(products) {
			var sortarray = [];
			var tabhtml = '';
			$.each(products, function (i, product) {
				if (product.category && product.category.hasOwnProperty('title')) {
					if (sortarray[product.category.title] === undefined) {
						sortarray[product.category.title] = [];
						sortarray[product.category.title].push(product);
					} else {
						sortarray[product.category.title].push(product);
					}
					//console.log(product); 
				}
				if (product.type && product.type !== 'hp-product') {
					if (sortarray[product.type] === undefined) {
						sortarray[product.type] = [];
						sortarray[product.type].push(product);
					} else {
						sortarray[product.type].push(product);
					}
				}
			});

			var tabnav = '<div class="tab-nav"><ul>';
			tabnav += '<li class="active"><a href="#taball" data-hp-tab="taball" > ALL </a></li>';
			var tabcontent = '';
			tabcontent += '<div id="taball" class="tab-item active"> ' + getSearchHtml(products, 'all') + '</div>';
			var tablist = 0;
			for (var key in sortarray) {
				tablist++;
				let value = sortarray[key];
				let clactive = '';
				tabnav += '<li><a href="#tab' + tablist + '" data-hp-tab="tab' + tablist + '" > ' + key + '</a></li>';
				tabcontent += '<div id="tab' + tablist + '" class="tab-item"> ' + getSearchHtml(value, key) + '</div>';
			}
			tabnav += '</ul></div>';
			tabhtml += '<div class="hp-saerch-tab">';
			tabhtml += tabnav;
			tabhtml += '<div id="tab-content" class="tab-content">' + tabcontent + '</div>';
			tabhtml += '</div>';

			return tabhtml;
			//return getSearchHtml(products);
		}/*getSearchResultsHtml*/

		function getSearchResourcesCenterHtml(search_container, resources) {
			let tabname = 'Document Library';
			let $tab_rs2_content = '.hp-search-results .tab-content';
			if (!search_container.find('.hp-search-results .tab-nav ul li.resource-center').length) {
				search_container.find('.hp-search-results .tab-nav ul').append('<li class="resource-center"><a href="#resources2" data-hp-tab="resources2">' + tabname + '</a></li>');
			}
			if (!search_container.find($tab_rs2_content + ' #resources2').length) {
				search_container.find($tab_rs2_content).append("<div id='resources2' class='tab-item'></div>");
			}
			search_container.find($tab_rs2_content + ' #resources2').html(getResourceSearchResultHtml(resources));

			if (!search_container.find($tab_rs2_content + ' #taball .resources-center-items').length) {
				var alltab_resource_HTML = '<div id="resources-center-items" class="resources-center-items">';
				alltab_resource_HTML += '<div class="resource-center-title">' + tabname + '</div>';
				alltab_resource_HTML += '<div id="resources-center-items-list" class="resources-center-items-list"></div>';
				alltab_resource_HTML += '</div> ';
				search_container.find($tab_rs2_content + ' #taball').append(alltab_resource_HTML);
			}
			search_container.find($tab_rs2_content + ' #taball .resources-center-items-list').html(getResourceSearchResultHtml(resources));
		}/*getSearchResourcesCenterHtml*/

		$(document).on('click', '.hp-saerch-tab .tab-nav a', function (e) {
			e.preventDefault();
			var btn = $(this),
				tab = btn.parents('.hp-saerch-tab'),
				target = btn.data('hp-tab');
			btn.parents('li').siblings().removeClass('active');
			btn.parents('li').addClass('active');
			tab.find('.tab-item').removeClass('active').hide();
			$(' #' + target).addClass('active').fadeIn(200);
		});

		function getSearchHtml(products, tab) {
			var html = ''; var loopcount =0;
			$.each(products, function (i, product) { loopcount++;
				if (product) {
					var wrapperClass = 'hp-search-result-item';
					if (product.featured_image) {
						wrapperClass += ' has-image';
					}
					html += '<div class="' + wrapperClass + '">';
					if (product.featured_image) {
						var tabname = tab.replace(/[^a-zA-Z0-9]/g, '');
						var img_id = tabname+loopcount;
						if(product.type == 'hp-product'){
						html += '<img id="'+img_id+'" src="' + hill_image(product.featured_image,100, img_id) + '">';
						}else{
							html += '<img src="' + product.featured_image + '">';
						}
					}
					html += '<h3 class="title">';
					if (product.type && product.type !== 'hp-product') {
						html += '<a href="' + hillphoenixJs.site_url + '/' + product.slug + '">';
					} else {
						html += '<a href="' + hillphoenixJs.site_url + '/' + hillphoenixJs.home + '/' + product.slug + '">';
					}

					if (product.category && product.category.hasOwnProperty('title')) {
						html += '<span>' + product.category.title + '</span>';
					}
					if (product.type && product.type !== 'hp-product') {
						html += '<span>' + product.type + '</span>';
					}
					html += product.title;
					html += '</a>';
					html += '</h3>';
					html += '<p>' + product.short_description + '</p>';

					if (product.product_resourses !== null && product.product_resourses !== undefined && product.product_resourses != '') {
						html += "<div class='resources-heading'>Resources</div>";
						html += '<ul>';
						for (var key in product.product_resourses) {
							$.each(product.product_resourses[key], function (i, item) {
								let path = item.disk_path.split("/");
								let item_type = item.type;
								if(item_type == null || item_type == ''){ item_type = "Other";}
								html += '<li class="hp-search-item-resources">';
								html += '<a href="' + item.url + '" target="_blank">' + item.name;
								html += '<span class="item-type">' + item_type + '</span></a></li>'
							})
						}/* for loop: end */
						html += '</ul>';
					}/* if product_resourse: end */
					html += '</div>';
				}
			});
			return html
		}
	}

	$.hillphoenix.handleResourceSearch = function () {
		var typingTimer;
		var searchBox = $('.hp-resource-center-search-wrapper input.hp-resource-center-search');
		searchBox.on('keyup', function () {
			var field = $(this),
				form = field.parents('form'),
				results = form.siblings('.results');
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function () {
				if (!field.val()) {
					results.html('<div class="hp-empty-message">Search text is required</div>').fadeIn();
					return;
				}
				form.addClass('search-is-active');
				$.ajax({
					type: 'POST',
					url: hillphoenixJs.ajax_url,
					data: {
						search: field.val(),
						nonce: form.data('nonce'),
						action: 'hillphoenix_search_resource'
					},
					beforeSend: function () {
						form.addClass('hp-is-loading')
					},
					success: function (r) {
						var response = JSON.parse(r);
						if (response.status.toString() === 'success') {
							if (response.data.length) {
								results.html(getResourceSearchResultHtml(response.data)).fadeIn();
							} else {
								results.html('<div class="hp-empty-message">No result found</div>').fadeIn();
							}
						} else {
							results.html('<div class="hp-empty-message">No result found</div>').fadeIn()
						}
					},
					error: function (e) {
						console.log(e);
					},
					complete: function () {
						form.removeClass('hp-is-loading')
					}
				})
			}, 500);
		});
		searchBox.on('keydown', function () {
			clearTimeout(typingTimer);
		});
		$('.hp-clear-resource-search').on('click', function (e) {
			e.preventDefault();
			var wrapper = $(this).parents('form');
			wrapper.find('input').val('');
			wrapper.siblings('.results').html('').hide();
			wrapper.removeClass('search-is-active');
		})
		$('.hp-resource-center .hp-resource-center-header form').on('submit', function (e) {
			e.preventDefault();
		})
	}
	// CHECK IF IMAGE EXISTS
	async function checkImageExists(url) {
		return new Promise(async (resolve) => {
			const img = new Image();
			img.onload = function () {
				resolve(true);
			};
			img.onerror = function () {
				resolve(false);
			};
			img.src = url;
		});
	}
	async function hill_image(url, addition, img_id) {
		var default_img = url;
		var a = document.createElement('a');
		a.href = decodeURI(url);
		var path = a.pathname.replace(/^([^\/])/, '/$1');
		var index = url.lastIndexOf("/") + 1;
		var filename = url.substring(index);
		var extension = filename.split('.').pop();
		filename = filename.replace(/\.[^/.]+$/, "");
		var name_ext= decodeURI(filename)+'.'+extension;
		path = decodeURI(path);
		path = path.replace(name_ext ,'');
		path = path.replace('hilldrive','files');
		var imageUrl = hillphoenixJs.site_url+path+filename+'_'+addition+'.'+extension; /*'https://www.hillphoenix.com'*/

		const exists = await checkImageExists(imageUrl);
		var imgElement = document.getElementById(img_id);
		if (exists) {
			imgElement.src = imageUrl;
		} else {
			imgElement.src = url;
		}
	}

	function getResourceSearchResultHtml(data) {
		var html = '<ul>';
		$.each(data, function (i, item) {
			let path = item.disk_path.split("/");
			let type = "Other";
			if (path.length > 4) {
				type = path[3];
			}
			html += '<li class="hp-search-result-item">';
			html += '<a href="' + item.url + '" target="_blank"> <span class="dir"> Document Library &raquo; ' + path[2] + ' </span> ' + item.name;
			html += '<span class="type">' + type + '</span></a></li>'
		})
		// html += '</ul>';
		return $.parseHTML(html);
	}

	$.hillphoenix.handleResourceTab = function () {
		$('.hp-resourse-tab .tab-nav a').on('click', function (e) {
			e.preventDefault();
			var btn = $(this),
				tab = btn.parents('.hp-resourse-tab'),
				target = btn.data('hp-tab');
			btn.parents('li').siblings().removeClass('active');
			btn.parents('li').addClass('active');
			tab.find('.tab-item').removeClass('active').hide();
			$(' #' + target).fadeIn(200);
		});
	}

	$.hillphoenix.fillCountsInitially = function () {
		$(document).ready(function () {
			var downloads = getCookie('hp_download_list');
			if (downloads.length) {
				downloads = JSON.parse(downloads);
				$('.hp-download-count span').html(downloads.length);
				$.each(downloads, function (i, download) {
					$('.hp-accordion ul li a[data-download-id="' + download.id + '"]').addClass('active');
				});
				updateAccordionToolsActiveStatus();
			}
			var compareList = getCompareList();
			if (compareList) {
				$('.hp-compare-count').html('(' + compareList.length + ')');
				$.each(compareList, function (i, compareItem) {
					$('.hp-compare-btn[data-product-id="' + compareItem + '"]').addClass('active').html('Added to compare');
				})
			}
		})
	};

	$.hillphoenix.addToDownloadList = function () {
		$('body').on('click', '.hp-add-download', function (e) {
			e.preventDefault();
			var btn = $(this),
				downloadId = btn.data('download-id'),
				downloadName = btn.data('download-name'),
				downloadUrl = btn.data('download-url');
			if (downloadId && downloadName && downloadUrl) {
				updateDownloadList({
					name: downloadName,
					id: downloadId,
					url: downloadUrl,
				})
			}
		});

		$('.hp-add-download-slide').on('click', function (e) {
			e.preventDefault();
			var el = $('.hpslider-for .slick-active .hp-slide-main-item'),
				downloadId = el.data('download-id'),
				downloadName = el.data('download-name'),
				downloadUrl = el.data('download-url');
			if (downloadId && downloadName && downloadUrl) {
				updateDownloadList({
					name: downloadName,
					id: downloadId,
					url: downloadUrl,
				})
			}

		});

		$('body').on('click', '.hp-add-download-group', function (e) {
			e.preventDefault();
			var btn = $(this),
				downloads = btn.parents('.accordion-item').find('.hp-add-download');
			if (downloads.length) {
				var list = getDownloadList() || [],
					counter = $('.hp-download-count span');

				if (btn.hasClass('active')) {
					btn.removeClass('active').html('<i class="hp-icon icon-plus-alt"></i><span>Add to downloads</span>');
					var ids = [];
					$.each(downloads, function (i, download) {
						var el = $(download);
						ids.push(el.data('download-id'));
						el.removeClass('active');
					});
					var filtered = list.filter(function (listItem) {
						return !ids.includes(listItem.id)
					});
					setCookie('hp_download_list', JSON.stringify(filtered), 1);
					counter.html(filtered.length);
					flashMessage('info', 'Removed from download list');
					return;
				}


				$.each(downloads, function (i, item) {
					var el = $(item),
						download = {
							name: el.data('download-name'),
							id: el.data('download-id'),
							url: el.data('download-url'),
						}
					if (!existInDownloadList(list, download)) {
						list.push(download);
						el.addClass('active')
					}
				});
				btn.addClass('active');
				btn.find('span').html('Added to downloads');
				btn.find('i').removeClass('icon-plus-alt').addClass('icon-check');
				setCookie('hp_download_list', JSON.stringify(list), 1);
				counter.html(list.length);
				flashMessage('success', 'Added in download list');
			}
		});
	}

	function updateAccordionToolsActiveStatus() {
		var accordions = $('.accordion-item');
		$.each(accordions, function (i, el) {
			var accordion = $(el),
				allDownloads = accordion.find('.hp-add-download'),
				activeDownloads = accordion.find('.hp-add-download.active'),
				card = accordion.parents('.card-info'),
				downloadGroupBtn = accordion.find('.hp-add-download-group');
			if (allDownloads.length === activeDownloads.length) {
				if (card.length) {
					var allBtn = card.find('.hp-add-download-all');
					if (allBtn.length) {
						allBtn.addClass('hp-active');
					}
				}
				downloadGroupBtn.addClass('active')
					.children('i')
					.removeClass('icon-plus-alt')
					.addClass('icon-check')
					.siblings('span').html('Added to downloads')
			} else {
				if (downloadGroupBtn.hasClass('active')) {
					if (card.length) {
						var allBtn = card.find('.hp-add-download-all');
						if (allBtn.length && allBtn.hasClass('hp-active')) {
							allBtn.removeClass('hp-active');
						}
					}
					downloadGroupBtn.removeClass('active')
						.children('i')
						.removeClass('icon-check')
						.addClass('icon-plus-alt')
						.siblings('span').html('Add to downloads')
				}
			}
		})
	}

	function updateDownloadList(item) {
		var list = getDownloadList() || [],
			counter = $('.hp-download-count span'),
			btn = $('.hp-add-download[data-download-id="' + item.id + '"]');
		if (!existInDownloadList(list, item)) {
			list.push(item);
			if (btn.length) {
				btn.addClass('active');
			}
			setCookie('hp_download_list', JSON.stringify(list), 1);
			counter.html(list.length);
			flashMessage('success', 'Added in download list');
		} else {
			var filtered = list.filter(function (listItem) {
				return listItem.id !== item.id
			})
			if (btn.length) {
				btn.removeClass('active');
			}
			setCookie('hp_download_list', JSON.stringify(filtered), 1);
			counter.html(filtered.length);
			flashMessage('info', 'Removed from download list');
		}

	}

	$.hillphoenix.showDownloadList = function () {
		$('.hp-download-count, .hp-download-count a').on('click', function (e) {
			e.preventDefault();
			var list = $('.hp-download-list'),
				downloads = getDownloadList();
			if (downloads) {
				var html = '';
				$.each(downloads, function (i, download) {
					html += downloadListHtml(download);
				});
				list.find('.hp-download-list-body').html($.parseHTML(html));
				list.fadeIn(300);
				return;
			}
			list.find('.hp-download-list-body').html('<p class="hp-empty-message">No downloads added in list</p>');
			list.fadeIn(300);
		});
	}

	$.hillphoenix.closeDownloadPopup = function () {
		$('.hp-download-list-close').on('click', function (e) {
			e.preventDefault();
			$('.hp-download-list').fadeOut(200);
		});
	}

	$.hillphoenix.removeFromDownloadList = function () {
		$('body').on('click', '.hp-remove-download', function (e) {
			e.preventDefault();
			var btn = $(this),
				downloadCount = $('.hp-download-count span'),
				downloads = getDownloadList(),
				target = btn.data('download-id');
			if (downloads) {
				var filtered = downloads.filter(function (item) {
					return item.id !== target
				});
				btn.parents('.hp-download-item').remove();
				downloadCount.html(filtered.length);
				$('.hp-add-download[data-download-id="' + target + '"]').removeClass('active');
				setCookie('hp_download_list', JSON.stringify(filtered), 1);
			}
		})
	}

	$.hillphoenix.addAllToDownloadList = function () {
		$(document).on('click', '.hp-add-download-all', function (e) {
			e.preventDefault();
			var btn = $(this),
				card = btn.parents('.card-info');
			if (!card.length) {
				card = btn.parents('.hp-gallery-modal')
			}
			if (card.length) {
				var all = card.find('.hp-add-download'),
					counter = $('.hp-download-count span'),
					groupBtns = card.find('.hp-add-download-group')
				if (all.length) {
					var downloads = getDownloadList() ?? [];
					if (btn.hasClass('hp-active')) {
						var ids = [];
						$.each(all, function (i, item) {
							var el = $(item);
							ids.push(el.data('download-id'));
							el.removeClass('active');
						});
						var filtered = downloads.filter(function (download) {
							return !ids.includes(download.id)
						});
						btn.removeClass('hp-active');
						setCookie('hp_download_list', JSON.stringify(filtered), 1);
						counter.html(filtered.length);
						$.each(groupBtns, function (i, groupBtn) {
							var el = $(groupBtn);
							el.removeClass('active').find('span').html('Add to downloads');
							el.find('i').removeClass('icon-check').addClass('icon-plus-alt');
						});
						flashMessage('info', 'Removed from download list');
					} else {
						all.each(function (i, elm) {
							var el = $(elm),
								item = {
									id: el.data('download-id'),
									name: el.data('download-name'),
									url: el.data('download-url'),
								};
							//$('.hp-add-download[data-download-id="'+el.data('download-id')+'"]').addClass('active');
							if (!existInDownloadList(downloads, item)) {
								downloads.push(item)
							}
						});
						var size = new TextEncoder().encode(JSON.stringify(downloads)).length;
						if (size > (4096 * 8 * 1024 * 5)) {
							flashMessage('warning', 'Maximum limit reached for download list, remove some and try to add one by one');
							return;
						}
						all.addClass('active');
						setCookie('hp_download_list', JSON.stringify(downloads), 1);
						counter.html(downloads.length);
						if (groupBtns.length) {
							$.each(groupBtns, function (i, groupBtn) {
								var el = $(groupBtn);
								el.addClass('active').find('span').html('Added to downloads');
								el.find('i').removeClass('icon-plus-alt').addClass('icon-check');
							});
						}
						btn.addClass('hp-active');
						flashMessage('success', 'Added in download list');
					}
				} else {
					flashMessage('warning', 'No resource found!!')
				}
			}

		});
	}

	$.hillphoenix.downloadResource = function () {
		$('body').on('click', '.hp-download-resource', function (e) {
			e.preventDefault();
			var btn = $(this),
				url = btn.attr('href');
			fetch(url).then(function (r) {
				return r.blob();
			}).then(function (blob) {
				const a = document.createElement('a');
				document.body.appendChild(a);
				a.style = 'display: none';
				a.href = window.URL.createObjectURL(blob);
				// a.target = '_blank';
				a.download = btn.data('download-name');
				a.click();
				a.remove();
				btn.removeClass('downloading');
			}).catch(function (error) {
				console.log(error);
			});
			/*$.ajax({
				type: 'POST',
				url: hillphoenixJs.ajax_url,
				xhrFields: {
					responseType: 'blob'
				},
				data: {
					file_url: url,
					action: 'hillphoenix_download_single'
				},
				success: function (r) {

					const a = document.createElement('a');
					document.body.appendChild(a);
					a.style = 'display: none';
					var blob = new Blob([r]);
					a.href = window.URL.createObjectURL(blob);
					a.target = '_blank';
					a.download = btn.data('download-name');
					a.click();
					a.remove();
					btn.removeClass('downloading');
				},
				error: function (e) {
					console.log(e);
				},
			})*/
		})
	}

	$.hillphoenix.clearDownloads = function () {
		$('.hp-clear-downloads-btn').on('click', function (e) {
			e.preventDefault();
			setCookie('hp_download_list', '', 0);
			$('.hp-add-download').removeClass('active');
			$('.hp-download-count span').html('0');
			updateAccordionToolsActiveStatus();
			$('.hp-download-list').hide();
		})
	}

	$.hillphoenix.accordion = function () {
		$('body').on('click', '.hp-accordion .accordion-item .accordion-head .accordion-title', function (e) {
			e.preventDefault();
			var btn = $(this),
				currentItem = btn.parents('.accordion-item'),
				activeItem = currentItem.siblings('.accordion-item.show'),
				reloadSlide = btn.parents('.hp-accordion').hasClass('hp-reload-slide');
			activeItem.find('.accordion-body').slideUp();
			currentItem.find('.accordion-body').slideDown();
			if (reloadSlide) {
				var slider = $('.hpslider-for'),
					nav = $('.hpslider-nav'),
					resources = currentItem.find('.accordion-body .hp-add-download');

				slider.find('.slick-slide').remove();
				nav.find('.slick-slide').remove();

				$.each(resources, function (i, item) {
					var el = $(item),
						url = el.data('download-url'),
						name = el.data('download-name'),
						id = el.data('download-id'),
						coverImage = el.data('cover-image'),
						extension = getExtensionFromUrl(url);
					if (isImage(extension)) {
						slider.slick('slickAdd', '<div class="item hp-image-slide hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-slide-main-item" src="' + url + '" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" alt="' + name + '"/></div></div>');
						nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-nav-item" src="' + url + '" alt="' + name + '"/></div></div>');
					} else if (isVideo(extension)) {
						slider.slick('slickAdd', '<div class="item hp-video-slide hp-filtered"><div class="item-wrapper"><video class="hp-slide-main-item" src="' + url + '" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" controls></div></div>');
						nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-nav-item" src="' + hillphoenixJs.public_url + 'assets/img/video-icon.jpeg" alt="' + name + '" /></div></div>');
					} else if (isPdf(extension)) {
						if (coverImage && coverImage.length) {
							slider.slick('slickAdd', '<div  class="item hp-filtered hp-pdf-slide" data-file-name="' + name + '" data-file-url="' + url + '"  data-slick-index="' + (i + 1) + '"><div id="hp-pdf-slide-' + id + '" class="item-wrapper hp-slide-main-item" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" alt="' + name + '" data-cover-image="' + coverImage + '"><img style="display:none;" src="' + coverImage + '"/></div></div>');
							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-nav-item" src="' + coverImage + '" alt="' + name + '"/></div></div>');
						} else {
							slider.slick('slickAdd', '<div  class="item hp-filtered hp-pdf-slide" data-file-name="' + name + '" data-file-url="' + url + '"><div id="hp-pdf-slide-' + id + '" class="item-wrapper hp-slide-main-item" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '"><a style="display:none;" href="' + url + '" target="_blank"><i class="hp-icon icon-pdf"></i><span>View file</span></a></div></div>')

							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><div class="hp-thumb-icon hp-nav-item"><i class="hp-icon icon-pdf"></i></div></div></div>');
						}
					} else if (is3d(extension)) {
						if (coverImage && coverImage.length) {
							slider.slick('slickAdd', '<div  class="item hp-filtered hp-3d-slide" id="hp-3d-slide" data-model-name="' + name + '" data-slick-index="' + (i + 1) + '"><div id="hp-3d-slide-' + id + '" class="item-wrapper hp-slide-main-item online_3d_viewer" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" alt="' + name + '" data-cover-image="' + coverImage + '"></div></div>');
							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-nav-item" src="' + coverImage + '" alt="' + name + '"/></div></div>');
						} else {
							slider.slick('slickAdd', '<div  class="item hp-filtered hp-3d-slide" id="hp-3d-slide" data-model-name="' + name + '"><div id="hp-3d-slide-' + id + '" class="item-wrapper hp-slide-main-item online_3d_viewer" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '"></div></div>')

							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><div class="hp-thumb-icon hp-nav-item"><i class="hp-icon icon-pdf"></i></div></div></div>');
						}
						//reinit o3dv
						loadO3dv('hp-3d-slide-' + id, url);
					} else {
						if (coverImage && coverImage.length) {
							slider.slick('slickAdd', '<div class="item hp-file-slide hp-filtered" data-file-name="' + name + '" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><img class="hp-slide-main-item" src="' + coverImage + '" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" alt="' + name + '" data-cover-image="' + coverImage + '"/></div></div>');
							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><img class="hp-nav-item" src="' + coverImage + '" alt="' + name + '"/></div>');
						} else {
							slider.slick('slickAdd', '<div class="item hp-file-slide hp-filtered" data-file-name="' + name + '"><div class="item-wrapper"><div class="hp-large-icon"><a href="' + url + '" target="_blank" data-download-id="' + id + '" data-download-name="' + name + '" data-download-url="' + url + '" class="hp-slide-main-item"><i class="hp-icon icon-pdf"></i><span>View file</span></a></div></div></div>')

							nav.slick('slickAdd', '<div class="item hp-filtered" data-slick-index="' + (i + 1) + '"><div class="item-wrapper"><div class="hp-thumb-icon hp-nav-item"><i class="hp-icon icon-pdf"></i></div></div></div>');
						}
					}
				});
			}
			currentItem.addClass('show');
			activeItem.removeClass('show');
			//show current slide resource name
			var currentSlide = $('.hpslider-for .slick-slide.slick-active'),
				tag = 'a';
			if (currentSlide.hasClass('hp-image-slide')) {
				tag = 'img'
			}
			if (currentSlide.hasClass('hp-video-slide')) {
				tag = 'video'
			}
			if (currentSlide.hasClass('hp-pdf-slide')) {
				//console.log($('.hp-current-slide-name').html(currentSlide.data('file-name')))
				$('.hp-current-slide-name').html(currentSlide.data('file-name'));
			}
			if (currentSlide.hasClass('hp-3d-slide')) {
				// console.log(currentSlide.data('model-name'))
				$('.hp-current-slide-name').html(currentSlide.data('model-name'));
			} else {
				// console.log('video',currentSlide.find(tag).data('download-name'));
				$('.hp-current-slide-name').html(currentSlide.find(tag).data('download-name'));
			}
		})
	}

	$.hillphoenix.toggleProductDescription = function () {
		$('.hp-see-more-btn').on('click', function (e) {
			e.preventDefault();
			var btn = $(this);
			btn.parents('.hp-short-content').hide();
			btn.parents('.hp-content').find('.hp-full-content').fadeIn(200);
		});
		$('.hp-see-less-btn').on('click', function (e) {
			e.preventDefault();
			var btn = $(this);
			btn.parents('.hp-full-content').hide();
			btn.parents('.hp-content').find('.hp-short-content').fadeIn(200);
		});

	}

	$.hillphoenix.initSlider = function () {
		$('.hpslider-for').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			asNavFor: '.hpslider-nav',
			swipe: true
		});
		$('.hpslider-nav').slick({
			infinite: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			asNavFor: '.hpslider-for',
			dots: false,
			focusOnSelect: true,
			arrows: true,
			// vertical: true,
			swipe: true,
			draggable: true,
			prevArrow: "<span class='hp-slider-arrow hp-slider-arrow-prev'><i class='hp-icon icon-chevron-left'></i></span>",
			nextArrow: "<span class='hp-slider-arrow hp-slider-arrow-next'><i class='hp-icon icon-chevron-right'></i></span>",

			responsive: [
				{
					breakpoint: 768,
					settings: {
						vertical: false,
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 576,
					settings: {
						vertical: false,
						slidesToShow: 3,
					}
				}
			]
		});
	}

	$.hillphoenix.toggleFilterArea = function () {
		$('.filter-title').on('click', function (e) {
			e.preventDefault();
			var parent = $(this).parents('.filter-items');
			//$(this).parents('.filter-items').toggleClass('show');
			parent.find('.hp-filter-options').slideToggle();
			parent.toggleClass('show')
		});
	}

	$.hillphoenix.filterProductAttributes = function () {
		$('.hp-filter-wrap .filter-item.type-filter .hp-checkbox input').on('change', function (e) {
			/*var filter = $(this),
				attId = filter.data('attribute-id'),
				remove = [],
				add = [],
				parent = filter.parents('.hp-filter-options'),
				key = 'hp_filter_'+ attId,
				allChecked = parent.find('.hp-checkbox input:checked'),
				value='';
			if(allChecked.length){
				$.each(allChecked, function (i, each){
					var el = $(each);
					value += el.val() + ','
				})
				add.push({
					key: key,
					value: rtrim(value, ',')
				})
			}else{
				remove.push(key);
			}
			filter.parents('.hp-sidebar-block').addClass('hp-is-loading');
			redirectWithNewQuery(buildQueryParams([
				{
					key: 'h_page',
					value: 1
				},
			].concat(add), remove));*/
			attributeFilter(this, '.hp-filter-wrap');
		})
	}

	$.hillphoenix.filterProductCategories = function () {
		$('.filter-item.type-category .hp-checkbox input').on('change', function (e) {
			var filter = $(this),
				checkedCategories = filter.parents('.hp-filter-options').find('input:checked'),
				categories = [];
			if (checkedCategories.length) {
				$.each(checkedCategories, function (i, item) {
					categories.push($(item).data('category-id'))
				});
			}
			if (categories.length) {
				redirectWithNewQuery(buildQueryParams([
					{
						key: 'h_page',
						value: 1
					},
					{
						key: 'h_category',
						value: categories.join(',')
					}
				]));
			} else {
				redirectWithNewQuery(buildQueryParams([
					{
						key: 'h_page',
						value: 1
					}
				], ['h_category']));
			}
		})
	}

	$.hillphoenix.selectProductPageOptions = function () {
		/*$(document).ready(function () {
			var query = getCurrentQuery();
			if(query){
				if(query.hasOwnProperty('order') && query.hasOwnProperty('orderBy')){
					var sortArgs = getSortArgs();
					Object.keys(sortArgs).map(function (key) {
						if(sortArgs[key].h_sort === query.order.toString().trim() && sortArgs[key].h_sort_by === query.orderBy.toString().trim()){
							$('.hp-product-sort').val(key);
						}
					});
				}
				if(query.hasOwnProperty('attributes')){
					query.attributes.map(function (item) {
						var filter;
						if(item.hasOwnProperty('set_id') && item.set_id){
							filter = $('input[value="' + item.value + '"][data-attribute-id="'+item.id+'"][data-attribute-set-id="'+item.set_id+'"]');
						}else{
							filter  = $('input[value="' + item.value + '"][data-attribute-id="'+item.id+'"][data-attribute-set-id=""]');
						}
						if(filter.length){
							filter.prop('checked', true);
							filter.parents('.filter-items').addClass('show');
						}
					})
				}
				if(query.hasOwnProperty('search')){
					$('.hp-search-form input').val(query.search);
				}
			}
		});*/
	}

	$.hillphoenix.addToCompare = function () {
		$('body').on('click', '.hp-compare-btn', function (e) {
			e.preventDefault();
			var btn = $(this),
				productId = btn.data('product-id'),
				count = $('.hp-compare-count'),
				list = getCompareList();
			if (productId) {
				if (list) {
					var exist = list.filter(function (item) {
						return parseInt(item) === parseInt(productId)
					});
					if (exist.length) {
						btn.removeClass('active').html('Add to compare <i class="hp-icon icon-plus-alt"></i>')
						list = list.filter(function (item) {
							return parseInt(item) !== parseInt(productId)
						});
						flashMessage('info', 'Product is removed from compare list');
					} else {
						btn.addClass('active').html('Added to compare')
						flashMessage('success', 'Product added in compare list');
						list.push(parseInt(productId));
						setTimeout(() => {
							//show the compare popup
							$('.hp-show-compare-btn').click();
						}, 500);
					}
					count.html('(' + list.length + ')');
					setCookie('hp_compare_list', JSON.stringify(list), 1);
				} else {
					btn.addClass('active').html('Added to compare');
					setCookie('hp_compare_list', JSON.stringify([productId]), 1);
					flashMessage('success', 'Product added in compare list');
					count.html('(1)');
					setTimeout(() => {
						//show the compare popup
						$('.hp-show-compare-btn').click();
					}, 500);
				}
			}
		});
	}

	$.hillphoenix.compareModal = function () {
		$('.hp-show-compare-btn').on('click', function (e) {
			e.preventDefault();
			var btn = $(this),
				list = $('.hp-compare-modal'),
				compareList = getCompareList(),
				nonce = btn.data('nonce')

			if (compareList) {
				list.find('.hp-modal-body').html('<p class="hp-empty-message">Loading products...</p>');
				list.fadeIn(300);
				$.ajax({
					type: 'POST',
					url: hillphoenixJs.ajax_url,
					data: {
						nonce: nonce,
						products: JSON.stringify(compareList),
						action: 'hillphoenix_get_compare_products'
					},
					success: function (r) {
						var response = JSON.parse(r);
						if (response.status.toString() === "success") {
							list.find('.hp-modal-body').html($.parseHTML(getCompareListHtml(response.data)));
						} else {
							list.find('.hp-modal-body').html('<p class="hp-empty-message">No products found</p>');
						}
					},
					error: function (e) {
						console.log(e);
					},
				})
				return;
			}
			list.find('.hp-modal-body').html('<p class="hp-empty-message">No products added in compare list</p>');
			list.fadeIn(300);
		});
	}

	$.hillphoenix.removeFromCompare = function () {
		$('body').on('click', '.hp-remove-compare', function (e) {
			e.preventDefault();
			var btn = $(this),
				compareList = getCompareList(),
				list = $('.hp-compare-modal'),
				productId = btn.data('product-id'),
				tableWrapper = $('.hp-compare-table');
			var newList = compareList.filter(function (item) {
				return item !== productId
			})
			if (newList.length) {
				$('.hp-compare-count').html('(' + newList.length + ')')
				$.ajax({
					type: 'POST',
					url: hillphoenixJs.ajax_url,
					data: {
						nonce: list.data('nonce'),
						products: JSON.stringify(newList),
						action: 'hillphoenix_get_compare_products'
					},
					beforeSend: function () {
						tableWrapper.addClass('hp-is-loading')
					},
					success: function (r) {
						var response = JSON.parse(r);
						if (response.status.toString() === "success") {
							list.find('.hp-modal-body').html($.parseHTML(getCompareListHtml(response.data)));
						} else {
							list.find('.hp-modal-body').html('<p class="hp-empty-message">No products found</p>');
						}
					},
					error: function (e) {
						console.log(e);
					},
					complete: function () {
						tableWrapper.removeClass('hp-is-loading')
					},
				})
			} else {
				$('.hp-compare-count').html('');
				list.find('.hp-modal-body').html('<p class="hp-empty-message">No products added in compare list</p>')
			}
			$('.hp-compare-btn[data-product-id="' + productId + '"]').removeClass('active').html('Add to compare <i class="hp-icon icon-plus-alt"></i>')
			setCookie('hp_compare_list', JSON.stringify(newList), 1);

		});
		$('.hp-clear-compare-list-btn').on('click', function (e) {
			e.preventDefault();
			$('.hp-compare-count').html('');
			$('.hp-compare-btn ').removeClass('active');
			setCookie('hp_compare_list', '', 0);
			$('.hp-compare-modal').fadeOut(200);
		})
	};

	$.hillphoenix.openFancyBox = function () {
		$('.hp-open-full-screen').on('click', function (e) {
			e.preventDefault();
			var slides = $('.hpslider-for .slick-slide'),
				startIndex = 0,
				allItems = [];
			$.each(slides, function (i, slide) {
				var el = $(slide).find('.hp-slide-main-item'),
					type = getType(slide),
					thumb = el.data('download-url');
				if (el.parents('.slick-slide').hasClass('slick-active')) {
					startIndex = i;
					//open HPXModelViewer if the file is 3D
					if (is3d(getExtensionFromUrl(el.data('download-url')))) {
						window.open('https://hpxmodel.hillstaging.com/#model=' + el.data('download-url'), '_blank');
					}
				}
				if (type === 'iframe') {
					var coverImage = el.data('cover-image');
					if (coverImage) {
						thumb = coverImage;
					} else {
						thumb = hillphoenixJs.public_url + 'assets/img/file-icon.png';
					}
					allItems.push({
						src: '<div class="hp-large-icon"><a href="' + el.data('download-url') + '" target="_blank"><i class="hp-icon icon-pdf"></i><span class="title">' + el.data('download-name') + '</span><span class="button">Download file</span></a></div>',
						type: 'html',
						thumb: thumb
					})
				} else if (type === 'video') {
					var coverImage = el.data('cover-image');
					if (coverImage) {
						thumb = coverImage;
					} else {
						thumb = hillphoenixJs.public_url + 'assets/img/video-icon.jpeg';
					}
					allItems.push({
						src: el.data('download-url'),
						type: type,
						thumb: thumb
					})
				} else {
					allItems.push({
						src: el.data('download-url'),
						type: type,
						thumb: thumb
					})
				}

			})
			window.Fancybox.show(allItems, {
				startIndex: startIndex
			});
		})
		$('body').on('click', '.hp-open-lightbox', function (e) {
			e.preventDefault();
			var btn = $(this),
				resources = btn.parents('.card-info').find('a.hp-view-resource'),
				allItems = [];
			$.each(resources, function (i, resource) {
				var el = $(resource),
					url = el.attr('href'),
					type = getTypeFromUrl(url),
					thumb = url;
				if (type === 'iframe') {
					thumb = hillphoenixJs.public_url + 'assets/img/file-icon.png';
				}
				allItems.push({
					src: url,
					type: type,
					thumb: thumb
				});
			});
			window.Fancybox.show(allItems);
		});
		$('body').on('click', '.hp-lightbox', function (e) {
			e.preventDefault();
			var img = $(this),
				source = img.attr('src');
			if (source.length) {
				window.Fancybox.show([{ src: source }]);
			}

		});
	};

	$.hillphoenix.downloadSlideItem = function () {
		$('.hp-download-slide').on('click', function (e) {
			e.preventDefault();
			var el = $('.hpslider-for .slick-slide.slick-active .hp-slide-main-item'),
				url = el.data('download-url');
			if (url) {
				openInNewWindow(url);
			}
		});
	};

	$.hillphoenix.showCurrentSlideName = function () {
		$('.hpslider-for').on('afterChange', function (event) {
			var currentSlide = $('.hpslider-for .slick-slide.slick-active'),
				tag = 'img';
			if (currentSlide.hasClass('hp-video-slide')) {
				tag = 'video'

				console.log('video tag', tag);
				console.log('video', currentSlide.find(tag).data('download-name'));
			}
			if (currentSlide.hasClass('hp-pdf-slide') || currentSlide.hasClass('hp-file-slide')) {
				$('.hp-current-slide-name').html(currentSlide.data('file-name'));
			} if (currentSlide.hasClass('hp-3d-slide')) {
				$('.hp-current-slide-name').html(currentSlide.data('model-name'));
			} else {
				$('.hp-current-slide-name').html(currentSlide.find(tag).data('download-name'));
			}

		});
	}

	$.hillphoenix.downloadAll = function () {
		$('.hp-download-all').on('click', function (e) {
			e.preventDefault();
			var btn = $(this),
				productId = btn.data('product-id');
			if (productId) {
				var list = [];
				$.each($('.hp-accordion .accordion-body .hp-add-download'), function (i, el) {
					var item = $(el);

					list.push({
						name: item.data('download-name'),
						url: item.data('download-url'),
					})
				});
				downloadAllRequest(list, btn.data('download-name'), btn);
			}
		});
		$('.hp-download-all-list').on('click', function (e) {
			e.preventDefault();
			var btn = $(this),
				list = getDownloadList();
			if (list) {
				/*var resourceIds = list.map(function (item) {
					return item.id;
				});*/
				btn.attr('disabled', true);
				downloadAllRequest(list, 'downloads-' + new Date().getTime() + '.zip', btn);
				return;
			}
			flashMessage('error', 'No items added in download list');
		})
	}
	function urlToPromise(url) {
		return new Promise(function (resolve, reject) {
			JSZipUtils.getBinaryContent(url, function (err, data) {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		});
	}
	var saveAs = saveAs
		// IE 10+ (native saveAs)
		|| (typeof navigator !== "undefined" &&
			navigator.msSaveOrOpenBlob && navigator.msSaveOrOpenBlob.bind(navigator))
		// Everyone else
		|| (function (view) {
			"use strict";
			// IE <10 is explicitly unsupported
			if (typeof navigator !== "undefined" &&
				/MSIE [1-9]\./.test(navigator.userAgent)) {
				return;
			}
			var
				doc = view.document
				// only get URL when necessary in case BlobBuilder.js hasn't overridden it yet
				, get_URL = function () {
					return view.URL || view.webkitURL || view;
				}
				, URL = view.URL || view.webkitURL || view
				, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
				, can_use_save_link = !view.externalHost && "download" in save_link
				, click = function (node) {
					var event = doc.createEvent("MouseEvents");
					event.initMouseEvent(
						"click", true, false, view, 0, 0, 0, 0, 0
						, false, false, false, false, 0, null
					);
					node.dispatchEvent(event);
				}
				, webkit_req_fs = view.webkitRequestFileSystem
				, req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
				, throw_outside = function (ex) {
					(view.setImmediate || view.setTimeout)(function () {
						throw ex;
					}, 0);
				}
				, force_saveable_type = "application/octet-stream"
				, fs_min_size = 0
				, deletion_queue = []
				, process_deletion_queue = function () {
					var i = deletion_queue.length;
					while (i--) {
						var file = deletion_queue[i];
						if (typeof file === "string") { // file is an object URL
							URL.revokeObjectURL(file);
						} else { // file is a File
							file.remove();
						}
					}
					deletion_queue.length = 0; // clear queue
				}
				, dispatch = function (filesaver, event_types, event) {
					event_types = [].concat(event_types);
					var i = event_types.length;
					while (i--) {
						var listener = filesaver["on" + event_types[i]];
						if (typeof listener === "function") {
							try {
								listener.call(filesaver, event || filesaver);
							} catch (ex) {
								throw_outside(ex);
							}
						}
					}
				}
				, FileSaver = function (blob, name) {
					// First try a.download, then web filesystem, then object URLs
					var
						filesaver = this
						, type = blob.type
						, blob_changed = false
						, object_url
						, target_view
						, get_object_url = function () {
							var object_url = get_URL().createObjectURL(blob);
							deletion_queue.push(object_url);
							return object_url;
						}
						, dispatch_all = function () {
							dispatch(filesaver, "writestart progress write writeend".split(" "));
						}
						// on any filesys errors revert to saving with object URLs
						, fs_error = function () {
							// don't create more object URLs than needed
							if (blob_changed || !object_url) {
								object_url = get_object_url(blob);
							}
							if (target_view) {
								target_view.location.href = object_url;
							} else {
								window.open(object_url, "_blank");
							}
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						}
						, abortable = function (func) {
							return function () {
								if (filesaver.readyState !== filesaver.DONE) {
									return func.apply(this, arguments);
								}
							};
						}
						, create_if_not_found = { create: true, exclusive: false }
						, slice
						;
					filesaver.readyState = filesaver.INIT;
					if (!name) {
						name = "download";
					}
					if (can_use_save_link) {
						object_url = get_object_url(blob);
						// FF for Android has a nasty garbage collection mechanism
						// that turns all objects that are not pure javascript into 'deadObject'
						// this means `doc` and `save_link` are unusable and need to be recreated
						// `view` is usable though:
						doc = view.document;
						save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a");
						save_link.href = object_url;
						save_link.download = name;
						var event = doc.createEvent("MouseEvents");
						event.initMouseEvent(
							"click", true, false, view, 0, 0, 0, 0, 0
							, false, false, false, false, 0, null
						);
						save_link.dispatchEvent(event);
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						return;
					}
					// Object and web filesystem URLs have a problem saving in Google Chrome when
					// viewed in a tab, so I force save with application/octet-stream
					// http://code.google.com/p/chromium/issues/detail?id=91158
					if (view.chrome && type && type !== force_saveable_type) {
						slice = blob.slice || blob.webkitSlice;
						blob = slice.call(blob, 0, blob.size, force_saveable_type);
						blob_changed = true;
					}
					// Since I can't be sure that the guessed media type will trigger a download
					// in WebKit, I append .download to the filename.
					// https://bugs.webkit.org/show_bug.cgi?id=65440
					if (webkit_req_fs && name !== "download") {
						name += ".download";
					}
					if (type === force_saveable_type || webkit_req_fs) {
						target_view = view;
					}
					if (!req_fs) {
						fs_error();
						return;
					}
					fs_min_size += blob.size;
					req_fs(view.TEMPORARY, fs_min_size, abortable(function (fs) {
						fs.root.getDirectory("saved", create_if_not_found, abortable(function (dir) {
							var save = function () {
								dir.getFile(name, create_if_not_found, abortable(function (file) {
									file.createWriter(abortable(function (writer) {
										writer.onwriteend = function (event) {
											target_view.location.href = file.toURL();
											deletion_queue.push(file);
											filesaver.readyState = filesaver.DONE;
											dispatch(filesaver, "writeend", event);
										};
										writer.onerror = function () {
											var error = writer.error;
											if (error.code !== error.ABORT_ERR) {
												fs_error();
											}
										};
										"writestart progress write abort".split(" ").forEach(function (event) {
											writer["on" + event] = filesaver["on" + event];
										});
										writer.write(blob);
										filesaver.abort = function () {
											writer.abort();
											filesaver.readyState = filesaver.DONE;
										};
										filesaver.readyState = filesaver.WRITING;
									}), fs_error);
								}), fs_error);
							};
							dir.getFile(name, { create: false }, abortable(function (file) {
								// delete file if it already exists
								file.remove();
								save();
							}), abortable(function (ex) {
								if (ex.code === ex.NOT_FOUND_ERR) {
									save();
								} else {
									fs_error();
								}
							}));
						}), fs_error);
					}), fs_error);
				}
				, FS_proto = FileSaver.prototype
				, saveAs = function (blob, name) {
					return new FileSaver(blob, name);
				}
				;
			FS_proto.abort = function () {
				var filesaver = this;
				filesaver.readyState = filesaver.DONE;
				dispatch(filesaver, "abort");
			};
			FS_proto.readyState = FS_proto.INIT = 0;
			FS_proto.WRITING = 1;
			FS_proto.DONE = 2;

			FS_proto.error =
				FS_proto.onwritestart =
				FS_proto.onprogress =
				FS_proto.onwrite =
				FS_proto.onabort =
				FS_proto.onerror =
				FS_proto.onwriteend =
				null;

			view.addEventListener("unload", process_deletion_queue, false);
			saveAs.unload = function () {
				process_deletion_queue();
				view.removeEventListener("unload", process_deletion_queue, false);
			};
			return saveAs;
		}(
			typeof self !== "undefined" && self
			|| typeof window !== "undefined" && window
			|| this.content
		));

	$.hillphoenix.quickViewModal = function () {
		$('.hp-quick-view').on('click', function (e) {
			e.preventDefault();
			var btn = $(this),
				productId = btn.data('product-id'),
				nonce = btn.data('nonce'),
				modal = $('.hp-quick-view-modal');
			if (productId) {
				$.ajax({
					type: 'POST',
					url: hillphoenixJs.ajax_url,
					data: {
						nonce: nonce,
						product_id: productId,
						action: 'hillphoenix_get_product'
					},
					success: function (r) {
						var response = JSON.parse(r);
						if (response.status.toString() === "success") {
							modal.find('.hp-modal-body').html($.parseHTML(getProductDetailsHtml(response.data)));
						} else {
							modal.find('.hp-modal-body').html(getProductDetailsHtml(response.message));
						}
					},
					error: function (e) {
						modal.find('.hp-modal-body').html(e);
						console.log(e);
					},
				})
				modal.fadeIn(300);
			}
		});
	}

	$.hillphoenix.closeModal = function () {
		$('.hp-modal-close').on('click', function (e) {
			e.preventDefault();
			$(this).parents('.hp-modal').fadeOut(200);
		});
	}

	$.hillphoenix.infiniteScroll = function () {
		var ajaxRequestOn,
			nextPage = 2,
			loadaft = 500;
		$(window).scroll(function () {

			var btn = $('.hp-scroll-pagination');
			if (btn.length) {
				var scrollThreshold = btn.offset().top - 50, //(btn.offset().top / 100) * 85,
					targetHeight = $(window).scrollTop() + $(window).height(),
					totalPage = btn.data('total-page'),
					wrapper = $('.hp-card-wrapper, .hp-gallery-grid');

				/*if(nextPage === 2){
					scrollThreshold = (btn.offset().top / 100) * 80
				}*/
				/*var btnTop = btn.offset().top,
					windowBottom = $(window).scrollTop() + $(window).height();

				console.log(btnTop, windowBottom);*/

				if (nextPage <= totalPage) {
					if (targetHeight >= loadaft) {
						if (!ajaxRequestOn) {
							ajaxRequestOn = true;
							$('.hp-loading_message').show();
							$.ajax({
								type: 'POST',
								url: getNextPageUrl(nextPage),
								beforeSend: function () {
									wrapper.addClass('hp-is-loading');
								},
								success: function (r) {
									var html = $(r),
										products = html.find('.hp-product-card, .hp-gallery-grid-item');
									if (html.length) {
										wrapper.append(products);
									}
									ajaxRequestOn = false;
									nextPage = nextPage + 1;
									loadaft = loadaft + 500;
									wrapper.removeClass('hp-is-loading');
									$('.hp-loading_message').hide();
								},
								error: function (e) {
									console.log(e);
								},
							});
						}
					}
				} else {
					$('.hp-loading_message').html('No more products to show').show();
				}
			}
		});
	}

	$.hillphoenix.hoverPreview = function () {
		$('body').on('mouseenter', '.hp-view-resource', function () {
			if ($(window).width() > 768) {
				var btn = $(this),
					url = btn.attr('href'),
					urlParts = url.split('.'),
					fileType = urlParts[urlParts.length - 1],
					imageType = ['jpg', 'jpeg', 'png', 'svg', 'gif'],
					offsetTop = btn.offset().top + (btn.height() / 2),
					offsetLeft = btn.offset().left,
					windowHeight = $(window).height(),
					currentTopPos = $(window).scrollTop(),
					currentBottomPos = currentTopPos + $(window).height(),
					previewWidth = 320 + 10,
					previewHeight = 340 + 20,
					listPage = btn.parents('.hp-accordion').hasClass('hp-list-accordion');
				if (imageType.includes(fileType.trim().toLowerCase())) {
					var preview = $('body').find('.hp-hover-preview');
					if (!preview.length) {
						preview = $('<div class="hp-hover-preview"><img src="' + url + '"></div>');
						$('body').append(preview);
					} else {
						preview.removeClass('hp-position-top hp-position-bottom hp-position-center')
						preview.html('<img src="' + url + '"></div>');
					}
					preview.addClass('hp-hover-active');
					if (windowHeight > 350) {
						if ((currentBottomPos - offsetTop) > (previewHeight / 2) && (offsetTop - currentTopPos) > (previewHeight / 2)) {
							preview.css({ "top": (offsetTop - (previewHeight / 2)) }).addClass('hp-position-center');
						} else if ((currentBottomPos - offsetTop) > previewHeight) {
							preview.css({ "top": (offsetTop - 20) }).addClass('hp-position-top');
						} else {
							preview.css({ "top": (offsetTop - (previewHeight - 35)) }).addClass('hp-position-bottom');
						}
						if (listPage) {
							preview.css({ "left": (offsetLeft - previewWidth) }).addClass('hp-arrow-right')
						} else {
							preview.css({ "left": (offsetLeft + btn.width() + 10) }).addClass('hp-arrow-left')
						}
						preview.fadeIn(200);
					}
				}
			}
		});
		$('body').on('mouseleave', '.hp-view-resource', function () {
			var preview = $('body').find('.hp-hover-preview');
			preview.removeClass('hp-hover-active');
			setTimeout(function () {
				if (!preview.hasClass('hp-hover-active')) {
					preview.fadeOut(100).remove();
				}
			}, 300)
		});
	}

	$.hillphoenix.relatedProducts = function () {
		$('.hp-related-products').on('change', function (e) {
			var select = $(this);
			if (select.val().trim().toString() !== 'hp-current') {
				resizeSelect(select);
				window.location.href = hillphoenixJs.site_url + '/' + hillphoenixJs.home + '/' + select.val();
			}
		});
		$('.hp-related-products').select2({
			searchable: true,
		});
		$('.hp-select2').select2({
			searchable: true,
			theme: 'default hp-select2',
			placeholder: ' Select Products'
		});
	}

	$.hillphoenix.globalSearch = function () {
		var $eventSelect = $(".hp-global-search select");
		$eventSelect.select2();
		$eventSelect.on('change', function (e) {
			var url = $(this).val();
			if (parseInt(url) !== -1 && url.length) {
				window.location.href = url;
			}
		});
		$('body').on('click', '.hp-global-search-icon button', function (e) {
			e.preventDefault();
			var btn = $(this),
				wrapper = $(this).parents('.hp-global-search'),
				searchBox = wrapper.find('.hp-global-search-content'),
				windowWidth = $(window).width();
			//searchBox.css({left: wrapper.offset().left});
			if (windowWidth < 1200) {
				searchBox.css({ width: windowWidth });
			} else {
				searchBox.css({ width: windowWidth * 0.55 });
			}
			searchBox.toggleClass('hp-global-search-active');
			searchBox.fadeToggle();
		});

		$(window).on('click', function (e) {
			$eventSelect.on("select2:open", function (e) {
				$(this).addClass('open');
			});
			$(document).on('select2:open', () => {
				document.querySelector('.select2-container--open .select2-search__field').focus();
			});
			$eventSelect.on("select2:close", function (e) { $(this).removeClass('open'); });
			//if(!$('body').hasClass('logged-in')){
			var el = $(e.target),
				hasParent = el.parents('.hp-global-search');
			if (!$(".hp-global-search select").hasClass('open')) {
				if (!el.hasClass('select2-search__field') && !hasParent.length) {
					var searchBoxes = $('.hp-global-search-content');
					$.each(searchBoxes, function (i, searchBox) {
						var box = $(searchBox);
						if (box.hasClass('hp-global-search-active')) {
							box.removeClass('hp-global-search-active').fadeOut();
						}
					});
				}
			}
			//}
		})

	}

	function is_image(url) {
		var img_ext = url.split(/[#?]/)[0].split('.').pop().trim();
		var allowed = ['jpg', 'jpeg', 'png', 'svg', 'JPG', 'JPEG', 'PNG', 'gif', 'GIF', 'SVG'];
		return allowed.includes(img_ext);
	}

	$.hillphoenix.handleResourceList = function () {
		$('.hp-resources-list .hp-resources-list-select .hp_resources_list').on('change', function (e) {
			var select = $(this);
			if (parseInt(select.val()) !== 0) {
				window.open(select.val())
			}
		});


		$('.hp-quick-settings .hp_products_filter').on('change', function (e) {
			e.preventDefault();
			var select = $(this);
			if (select.val().length > 0) {
				var requestData = {
					id: select.val().toString(),
					//nonce: container.data('nonce'),
					action: 'hillphoenix_filter_products_by_ids'
				};
				$.ajax({
					type: 'POST',
					url: hillphoenixJs.ajax_url,
					data: requestData,
					beforeSend: function () {
						//container.addClass('hp-is-loading');
					},
					success: function (r) {
						var response = JSON.parse(r);
						var pro_container = $("#product-archive .hp-card-wrapper .hp-product-card");
						if (response.length > 0) {
							pro_container.each(function () {
								$(this).fadeOut(1000);
							});
						_gen_ProductsHtml(response);
						}/*response.length*/
					},
					error: function (e) {
						console.log(e);
					},
					complete: function () {
						//container.removeClass('hp-is-loading');
					}
				});
			} else {
				$("#product-archive .hp-card-wrapper .filter-products").html('');
				$("#product-archive .hp-card-wrapper .hp-product-card").each(function () {
					$(this).fadeIn(1000);
				});
			}
		});

		function _gen_ProductsHtml(response) {
			var pro_html = '';
			$.each(response, function (i, product) {
				var product_url = hillphoenixJs.site_url + '/' + hillphoenixJs.home + '/' + product.slug;
				pro_html += '<div class="hp-product-card">';
				pro_html += '<div class="card-thumb">';
				if (product.featured_image.length > 0) {
					pro_html += '<a href="' + product_url + '"><img src="' + product.featured_image + '" alt="' + product.title + '"></a>';
				} else {
					pro_html += '<a href="' + product_url + '"><img src="' + hillphoenixJs.public_url + 'assets/img/fallback.jpeg" alt="' + product.title + '"></a>';
				}
				pro_html += '</div>';
				pro_html += '<div class="card-body">';
				pro_html += '<div class="card-content">';
				pro_html += '<h2>';
				pro_html += '<a href="' + product_url + '">' + product.title + '</a>';
				if (product.variations.length > 0) {
					$.each(product.variations, function (i, variation) {
						pro_html += '<span >&#44;</span>&nbsp;';
						pro_html += '<a href="' + hillphoenixJs.site_url + '/' + hillphoenixJs.home + '/' + variation.slug + '">' + variation.title + '</a>';
					});
				}
				pro_html += '</h2>';
				pro_html += '<p>' + product.short_description + '</p>';
				pro_html += '<a href="' + product_url + '" class="hp-link">View Details <i class="hp-icon icon-chevron-right"></i></a>';
				if (product.is_comparable == 1) {
					pro_html += '<a href="#" class="hp-link hp-compare-btn" data-product-id="' + product.id + '"> Add to compare<i class="hp-icon icon-plus-alt"></i></a>';
				}
				pro_html += '</div>';/*card-content*/
				pro_html += '<div class="card-info">';
				pro_html += '<div class="hp-dflex">';
				pro_html += '<h3>Resources</h3>';

				if (product.hasOwnProperty('resources')) {
					pro_html += '<div class="hp-resource-nav">';
					pro_html += '<a href="#" class="hp-open-lightbox" data-product-id="' + product.id + '">View all <i class="hp-icon icon-eye"></i></a>';
					pro_html += '<a href="#" class="hp-add-download-all" data-product-id="' + product.id + '">Add All To Download <i class="hp-icon icon-download"></i></a>';
					pro_html += '</div>';
				}
				pro_html += '</div>'; /*hp-dflex*/

				if (product.hasOwnProperty('resources')) {
					pro_html += '<div class="hp-accordion hp-list-accordion">';
					var show_fidx = true;
					
					$.each(product.resources, function (i, resources) {
						if (i == "Shared Media") { return; }

						pro_html += '<div class="accordion-item ';
						if (show_fidx) {	pro_html += ' show';	}
						pro_html += '">';

						pro_html += '<div class="accordion-head">';

						pro_html += '<div class="accordion-title accordion-trigger">';
						if (i.length > 0) { var rec_name = i.toUpperCase(); } else { var rec_name = 'All' }
						pro_html += '<p>' + rec_name + '</p>';
						pro_html += '</div>';

						pro_html += '<div class="accordion-tools">';
						pro_html += '<a href="#" class="hp-add-download-group"><i class="hp-icon icon-plus-alt"></i> <span>Add to downloads</span></a>';
						pro_html += '</div>';

						pro_html += '</div>';/*accordion-head*/

						pro_html += '<div class="accordion-body" ';
						if (show_fidx) {
							pro_html += ' style="display:block"';
							show_fidx = false;
						}
						pro_html += '>';

						pro_html += '<ul>';
						$.each(resources, function (r, resource) {
							pro_html += '<li>';
							pro_html += '<span class="icons">';
							var cover_image = resource.hasOwnProperty('cover_image') && resource.cover_image != null ? resource.cover_image.url : '';
							pro_html += '<a href="#" data-download-id="' + resource.id + '" data-download-name="' + resource.name + '" data-download-url="' + resource.url + '" class="hp-add-download" data-cover-image="' + cover_image + '"></a>';
							pro_html += '<a href="' + resource.url + '" target="_blank" class="hp-view-resource r-' + resource.id + '" data-title="' + resource.name + '">';
							if (is_image(resource.url)) {
								pro_html += '<i class="hp-icon icon-search" style="padding: 4px;"></i>';
							} else {
								pro_html += '<i class="hp-icon icon-pdf"></i>';
							}
							pro_html += '</a>';/*hp-view-resource*/
							pro_html += '</span>';/*icons*/
							pro_html += '<span class="text">' + resource.name + '</span>';
							pro_html += '</li>';
						});
						pro_html += '</ul>';

						pro_html += '</div>';/*accordion-body*/
						
						pro_html += '</div>'; /*accordion-item*/
					});/*each product.resources*/
					pro_html += '</div>'; /*hp-accordion*/
				} else {
					pro_html += ' <p class="empty-message"> No resources found</p>';
				}/*hasOwnProperty('resources')*/
				pro_html += '</div>'; /*card-info*/
				pro_html += '</div>'; /*card-body*/
				pro_html += '</div>'; /*hp-product-card*/
			});
			$("#product-archive .hp-card-wrapper .filter-products").html(pro_html);
		}

		$('.hp-resources-list .hp-resources-list-select .hp_products_list').on('change', function (e) {
			var select = $(this);
			var selectedProducts = select.val();
			// console.log(select.val());
			if (selectedProducts.length > 0) {
				// window.open(select.val())
				reloadResources(1);
			}
		});
		$('.hp-resources-list .hp-resources-list-sorting select').on('change', function (e) {
			reloadResources(1);
		});
		$('.hp-resources-list .hp-resources-list-pagination a').on('click', function (e) {
			e.preventDefault();
			var btn = $(this);
			if (btn.hasClass('active')) {
				return;
			}
			reloadResources(btn.data('hp-page'));
		});

		$('.hp-resources-filter .filter-item input[type="checkbox"]').on('change', function (e) {
			reloadResources(1);
		})

		$('.hp-services-filter .filter-item input[type="checkbox"]').on('change', function (e) {
			reloadResources(1);
		})

	}

	$.hillphoenix.galleryPopup = function () {
		$('body').on('click', '.hp-gallery-grid-item .link', function (e) {
			e.preventDefault();
			var btn = $(this),
				productTitle = btn.parents('.grid-body').find('.title').html(),
				modal = $('.hp-gallery-modal'),
				slider = $('.hp-gallery-slide');
			modal.find('.hp-modal-header h3').html(productTitle);
			modal.find('.hp-add-download-all').attr('data-product-id', btn.data('product-id'))

			$.ajax({
				type: 'POST',
				url: hillphoenixJs.ajax_url,
				data: {
					product_id: btn.data('product-id'),
					nonce: modal.data('nonce'),
					action: 'hillphoenix_get_product_gallery'
				},
				success: function (r) {
					var response = JSON.parse(r);
					slider.find('.slick-slide').remove();
					if (response.status.toString() === 'success') {
						$.each(response.data, function (i, item) {
							slider.slick('slickAdd', '<div class="item" data-slick-index="' + (i + 1) + '"><h5 class="title" title="' + item.name + '">' + item.name + '</h5><img class="hp-slide-main-item" src="' + item.url + '" alt="' + item.name + '"/><a href="' + item.url + '" class="hp-add-download" data-download-id="' + item.id + '" data-download-name="' + item.name + '" data-download-url="' + item.url + '"><i class="hp-icon icon-plus-alt"></i> <span>Add to download</span></a></div>');
						});
					} else {
						slider.slick('slickAdd', '<div data-slick-index="0">' + response.message + '</div>');
					}

				},
				error: function (e) {
					console.log(e);
				},
			})
			modal.fadeIn();
		});
		$('.hp-gallery-slide').slick({
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1
		});
		$('.hp-gallery-modal-close').on('click', function (e) {
			e.preventDefault();
			$(this).parents('.hp-modal').fadeOut(200);
			var slider = $('.hp-gallery-slide');
			setTimeout(function () {
				slider.find('.slick-slide').remove();
				slider.slick('slickAdd', '<div class="item" data-slick-index="0">Loading images...</div>');
			}, 300)

		});
	}

	$.hillphoenix.initO3dv = function () {
		OV.SetExternalLibLocation('../../o3dv/libs'); // tell the engine where to find the libs folder
		OV.Init3DViewerElements();
	}

	function loadO3dv(parent, modelurl) {
		// tell the engine where to find the libs folder
		OV.SetExternalLibLocation('../../o3dv/libs');

		// get the parent element of the viewer
		let parentDiv = document.getElementById(parent);

		// initialize the viewer with the parent element and some parameters
		let viewer = new OV.EmbeddedViewer(parentDiv, {
			// camera : new OV.Camera (
			// 	new OV.Coord3D (-1.5, -3.0, 2.0),
			// 	new OV.Coord3D (0.0, 0.0, 0.0),
			// 	new OV.Coord3D (0.0, 0.0, 0.0)
			// ),
			backgroundColor: new OV.RGBAColor(255, 255, 255, 255),
			defaultColor: new OV.RGBColor(200, 200, 200),
			edgeSettings: {
				showEdges: false,
				edgeColor: new OV.RGBColor(0, 0, 0),
				edgeThreshold: 1
			},
			environmentSettings: {
				environmentMap: [
					'./envmaps/park.jpg',
					// 'envmaps/fishermans_bastion/negx.jpg',
					// 'envmaps/fishermans_bastion/posy.jpg',
					// 'envmaps/fishermans_bastion/negy.jpg',
					// 'envmaps/fishermans_bastion/posz.jpg',
					// 'envmaps/fishermans_bastion/negz.jpg'
				],
				backgroundIsEnvMap: false
			},
			onModelLoaded: () => {
				// let model = viewer.GetModel ();
				// do something with the model
			}
		});

		// load a model providing model urls
		var murls = [];
		murls.push(modelurl);
		viewer.LoadModelFromUrlList(murls);
	}

	function reloadResources(page) {
		var container = $('.hp-resources-list-wrapper'),
			filterAttributes = container.find('.hp-sidebar .hp-filter-options'),
			filterServices = container.find('.hp-sidebar .hp-service-options'),
			sort = container.find('.hp-resources-list-sorting select').val(),
			sortArgs = getSortArgs(),
			productIds = container.find('.hp-resources-list .hp-resources-list-select .hp_products_list').val(),
			filters = [],
			services = [],
			requestData = {
				page: page,
				nonce: container.data('nonce'),
				action: 'hillphoenix_resource_list'
			};

		if (sortArgs[sort]) {
			requestData.order = sortArgs[sort].h_sort;
			requestData.orderBy = sortArgs[sort].h_sort_by;
		}
		if (typeof container.data('resource-types') !== "undefined") {
			requestData.resource_types = container.data('resource-types');
		}

		if (typeof productIds !== "undefined" && productIds.length > 0) {
			requestData.product_ids = productIds.toString();
		}

		$.each(filterAttributes, function (i, attribute) {
			var activeFilters = $(attribute).find('.hp-checkbox input[type="checkbox"]:checked');
			if (activeFilters.length) {
				var data = {
					id: '',
					values: []
				};
				$.each(activeFilters, function (i2, elm) {
					var item = $(elm);
					if (i2 === 0) {
						data.id = item.data('attribute-id')
					}
					data.values.push(item.val());
				});
				filters.push(data);
			}
		});
		if (filters.length) {
			requestData.filters = JSON.stringify(filters);
		}

		//services filter
		$.each(filterServices, function (i, attribute) {
			var activeFilters = $(attribute).find('.hp-checkbox input[type="checkbox"]:checked');
			if (activeFilters.length) {
				$.each(activeFilters, function (i2, elm) {
					var item = $(elm);
					services.push(item.val());
				});
			}
		});
		if (services.length) {
			requestData.service_types = services.toString();
			//console.log(requestData.service_types);
		}

		$.ajax({
			type: 'POST',
			url: hillphoenixJs.ajax_url,
			data: requestData,
			beforeSend: function () {
				container.addClass('hp-is-loading');
			},
			success: function (r) {
				var response = JSON.parse(r);
				if (response.status.toString() === 'success') {
					if (response.data.length) {
						container.find('.hp-resources-list-content').html(getResourceListHtml(response.data));
						$('.hp-resources-list-pagination li a.active').removeClass('active')
						$('.hp-resources-list-pagination li a[data-hp-page="' + page + '"]').addClass('active');
					} else {
						container.find('.hp-resources-list-content').html('<div class="hp-empty-message">No resources found</div>');
					}
				} else {
					container.find('.hp-resources-list-content').html('<div class="hp-empty-message">' + response.message + '</div>');
				}
			},
			error: function (e) {
				console.log(e);
			},
			complete: function () {
				container.removeClass('hp-is-loading');
			}
		});
	}


	function getResourceListHtml(resources) {
		var html = '';
		$.each(resources, function (i, resource) {
			html += '<div class="hp-resource-list-item">';

			html += '<div class="hp-resource-details">';
			html += '<h3>' + resource.name + '</h3>'
			html += '</div>';

			html += '<div class="hp-resource-action">';
			html += '<a href="' + resource.url + '" class="hp-download-resource" target="_blank" data-download-name="' + resource.name + '"><i class="hp-icon icon-download"></i> <span>Download now</span></a>';
			html += '<a href="' + resource.url + '" class="hp-add-download" data-download-id="' + resource.id + '" data-download-name="' + resource.name + '" data-download-url="' + resource.url + '"><i class="hp-icon icon-plus-alt"></i> <span>Add to download</span></a>'
			html += '</div>';

			html += '</div>';
		});
		return html;
	}
	function resizeSelect(select) {
		var text = select.find('option:selected').text(),
			temp = $('<select/>').append($('<option/>').text(text));
		select.after(temp)
		select.width(temp.width())
		temp.remove()
	}

	function downloadAllRequest(list, fileName, btn) {
		flashMessage('success', 'Your download will be completed shortly, please wait', 'Download started', 4000);
		/*$.extend(data, {
			action: 'hillphoenix_download_all'
		})
		$.ajax({
			type: 'POST',
			url: hillphoenixJs.ajax_url,
			xhrFields: {
				responseType: 'blob'
			},
			data: data,
			success: function (r) {
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.style = 'display: none';
				var blob = new Blob([r]);
				a.href = window.URL.createObjectURL(blob);
				a.target = '_blank';
				a.download = fileName;
				a.click();
				a.remove();
				btn.attr('disabled', false);
			},
			error: function (e) {
				console.log(e);
			},
		})*/
		var zip = new JSZip();
		$.each(list, function (i, item) {
			zip.file(item.name, urlToPromise(item.url), { binary: true });
		})
		zip.generateAsync({ type: 'blob' })
			.then(function (content) {
				fileName = fileName || 'downloads-' + (new Date()).getTime();
				fileName = fileName || 'downloads-' + (new Date()).getTime();
				saveAs(content, fileName + '.zip');
				flashMessage('success', 'Downloaded successfully');
				btn.attr('disabled', false);
			})
			.catch(function (error) {
				flashMessage('error', 'Error in download, : ' + error);
			});
	}

	function getNextPageUrl(page) {
		var url = window.location.protocol + '//' + window.location.hostname;

		if (window.location.pathname.length && window.location.pathname.toString() !== '/') {
			url += window.location.pathname;
		}
		var params = new URLSearchParams(window.location.search);
		params.set('h_page', page);
		url += '?' + params.toString();
		return url;
	}

	function attributeFilter(el, wrapper) {
		var filter = $(el),
			attId = filter.data('attribute-id'),
			remove = [],
			add = [],
			parent = filter.parents('.hp-filter-options'),
			key = 'hp_filter_' + attId,
			allChecked = parent.find('.hp-checkbox input:checked'),
			value = '';
		if (allChecked.length) {
			$.each(allChecked, function (i, each) {
				var el = $(each);
				value += el.val() + ','
			})
			add.push({
				key: key,
				value: rtrim(value, ',')
			})
		} else {
			remove.push(key);
		}
		filter.parents(wrapper).addClass('hp-is-loading');
		redirectWithNewQuery(buildQueryParams([
			{
				key: 'h_page',
				value: 1
			},
		].concat(add), remove));
	};

	function flashMessage(type, message, title, timeOut) {
		type = type || 'success';
		title = title || '';
		timeOut = timeOut || 2500;
		toastr[type](message, title, {
			newestOnTop: true,
			closeButton: true,
			showDuration: 200,
			hideDuration: 200,
			timeOut: timeOut,
			progressBar: true,
			toastClass: 'hp-toast',
		});
	}

	function getType(el) {
		el = $(el);
		if (el.hasClass('hp-video-slide')) {
			return 'video';
		}
		if (el.hasClass('hp-file-slide')) {
			return 'iframe';
		}
		if (el.hasClass('hp-pdf-slide')) {
			return 'iframe';
		}
		if (el.hasClass('hp-3d-slide')) {
			return 'iframe';
		}
		return 'image'
	}

	function getTypeFromUrl(url) {
		var extension = getExtensionFromUrl(url);
		if (isImage(extension)) {
			return 'image';
		}
		if (isPdf(extension)) {
			return 'pdf';
		}
		if (isVideo(extension)) {
			return 'video';
		}
		return 'iframe'
	}
	function getExtensionFromUrl(url) {
		var urlParts = url.split('.');
		return urlParts[urlParts.length - 1];
	}

	function isImage(extension) {
		return ['jpg', 'jpeg', 'png', 'gif', 'svg', 'JPG', 'JPEG', 'PNG', 'gif', 'GIF', 'SVG'].includes(extension)
	}
	function isPdf(extension) {
		return ['pdf', 'PDF'].includes(extension)
	}
	function is3d(extension) {
		return ['obj', 'OBJ', 'zip', 'ZIP'].includes(extension)
	}
	function isVideo(extension) {
		return ['mp4', 'mkv', 'ogg', '3gp', 'MP4', 'MKV', 'OGG', '3GP'].includes(extension)
	}

	function getProductDetailsHtml(product) {
		var html = '<div class="hp-product-quick-view">';
		if (product.featured_image) {
			html += '<div class="hp-product-image"><img src="' + product.featured_image + '" alt="' + product.title + '"></div>'
		}
		html += '<div class="hp-product-info">';
		html += '<h3 class="hp-product-title">' + product.title + '</h3>';
		html += '<div class="hp-product-description">' + product.description + '</div>'
		html += '</div>';

		html += '<div class="hp-info-wrap">';

		html += '<div class="info-item">';
		html += '<div class="info-head"><p>Features & Benefits</p></div>';
		html += '<div class="info-body">';
		if (product.features_and_benefits) {
			html += product.features_and_benefits;
		} else {
			html += '<h5>No features & benefits found</h5>'
		}
		html += '</div></div>';

		html += '<div class="info-item">';
		html += '<div class="info-head"><p>Available Options</p></div>';
		html += '<div class="info-body">';
		if (product.available_options) {
			html += product.available_options;
		} else {
			html += '<h5>No available options</h5>'
		}
		html += '</div></div>';

		html += '<div class="info-item">';
		html += '<div class="info-head"><p>Attributes</p></div>';
		html += '<div class="info-body">';
		if (product.attributes && product.attributes.length) {
			html += '<ul>';
			$.each(product.attributes, function (i, attribute) {
				if (attribute.attribute_value) {
					if (attribute.attribute_set_id) {
						html += '<li><strong>' + attribute.attribute_label + '(' + attribute.attribute_set_title + '): </strong> ' + attribute.attribute_value + '</li>';
					} else {
						html += '<li><strong>' + attribute.attribute_label + ': </strong> ' + attribute.attribute_value + '</li>';
					}
				}

			});
			html += '</ul>'
		} else {
			html += '<h5>No attributes found</h5>'
		}
		html += '</div></div>';


		html += '</div>';
		html += '</div>';
		return html;
	}
	function openInNewWindow(url) {
		var win = window.open(url, '_blank');
		if (!win) {
			alert('Enable popup for this website');
			return false;
		}
		return true;
	}

	function getCompareListHtml(data) {
		var html = '<div class="hp-compare-table"> <table><tbody>',
			columns = 0,
			crossSection = '<td class="hp-compare-title">Cross section image</td>';

		$.each(data, function (key, item) {

			switch (key.toString()) {
				case 'id':
					columns = item.values.length;
					break;
				case 'title':
					html += '<tr>';
					html += '<td class="hp-compare-title"></td>';//' + item.label + '
					$.each(item.values, function (i, value) {
						html += '<td class="hp-compare-info " style="text-align:center;"><div class="hp-has-remove-icon">' + value.replaceAll(",", ", ") + ' <span class="hp-icon icon-times hp-remove-compare" data-product-id="' + data.id.values[i] + '"></span></div></td>';
					})
					html += '</tr>';
					break;
				case 'featured_image':
					html += '<tr>';
					html += '<td class="hp-compare-title"></td>'; //' + item.label + '
					$.each(item.values, function (i, value) {
						html += '<td class="hp-compare-info" style="text-align:center;">';
						if (value && value.trim() !== '-') {
							html += '<a href="' + value + '" target="_blank" title="Open in new tab"><img src="' + value + '"/></a>';
						} else {
							html += '<img src="' + hillphoenixJs.public_url + '/assets/img/fallback.jpeg' + '"/>';
						}
						html += '</td>'
					});
					html += '</tr>';
					break;
				case 'cross_section':
					$.each(item.values, function (i, value) {
						crossSection += '<td class="hp-compare-info" style="text-align:center;">';
						if (value && value.trim() !== '-') {
							crossSection += '<a href="' + value + '" target="_blank" title="Open in new tab"><img src="' + value + '"/></a>';
						} else {
							crossSection += '<img src="' + hillphoenixJs.public_url + '/assets/img/fallback.jpeg' + '"/>';
						}
						crossSection += '</td>'
					});
					break;
				default:
					html += '<tr>';
					html += '<td>' + item.label + '</td>';
					$.each(item.values, function (i, value) {
						if (value) {
							html += '<td class="hp-compare-info">' + value.replaceAll(",", ", ") + '</td>';
						} else {
							html += '<td class="hp-compare-info">-</td>';
						}

					});
					html += '</tr>';


			}
		})
		html += '<tr>' + crossSection + '</tr>'
		html += '</tbody></table></div>';
		return html;
	}
	function getCompareList() {
		var list = getCookie('hp_compare_list');
		if (list.length) {
			list = JSON.parse(list);
			if (list.length) {
				return list;
			}
		}
		return null;
	}

	function getSortArgs() {
		return {
			default: {
				h_sort: 'desc',
				h_sort_by: 'id'
			},
			title_asc: {
				h_sort: 'asc',
				h_sort_by: 'title'
			},
			title_desc: {
				h_sort: 'desc',
				h_sort_by: 'title'
			},
			date: {
				h_sort: 'desc',
				h_sort_by: 'created_at'
			},
			file_order: {
				h_sort: 'asc',
				h_sort_by: 'order'
			},
		}
	}
	function setQuery(query) {
		var currentPath = window.location.pathname.replaceAll('/', '');
		if (currentPath.trim().toString() === hillphoenixJs.home.trim().toString()) {
			setCookie('hp_main_query', JSON.stringify(query), 1, window.location.pathname);
		} else {
			setCookie('hp_query', JSON.stringify(query), 1, window.location.pathname);
		}

	}

	function buildQueryParams(newParams, removeParams) {
		var params = new URLSearchParams(window.location.search);
		newParams.map(function (item) {
			if (params.get(item.key)) {
				params.set(item.key, item.value);
			} else {
				params.append(item.key, item.value);
			}
		});
		if (removeParams && removeParams.length) {
			removeParams.map(function (item) {
				if (params.get(item)) {
					params.delete(item);
				}
			});
		}

		return params;
	}

	function redirectWithNewQuery(params) {
		var url = window.location.protocol + '//' + window.location.hostname;
		if (window.location.pathname.length && window.location.pathname.toString() !== '/') {
			url += window.location.pathname;
		}
		if (params) {
			url += '?' + params.toString();
		}
		window.location.href = url;
	}

	function existInDownloadList(list, item) {
		return list.filter(function (each) {
			return each.id === item.id
		}).length;
	}

	function getDownloadList() {
		var downloads = getCookie('hp_download_list');
		if (downloads.length) {
			downloads = JSON.parse(downloads);
			if (downloads.length) {
				return downloads;
			}
		}
		return null
	}

	function downloadListHtml(item) {
		var html = '';
		html += '<div class="hp-download-item">';
		html += '<h4>' + item.name + '</h4>'
		html += '<div class="download-links">';
		html += '<a href="' + item.url + '" download="' + item.name + '" data-download-name="' + item.name + '" class="hp-download-resource" target="_blank"><i class="hp-icon icon-download"></i></a>'
		html += '<button data-download-id="' + item.id + '" class="hp-remove-download"><i class="hp-icon icon-times"></i></button>'
		html += '</div>';
		html += '</div>';

		return html;
	}
	function rtrim(str, chr) {
		var rgxtrim = (!chr) ? new RegExp('\\s+$') : new RegExp(chr + '+$');
		return str.replace(rgxtrim, '');
	}

	// On swipe event
	$('body').on('init reInit', '.hpslider-for', function (event, slick) {
		var currentSlide = slick.$slides.get(0);
		var id = $(currentSlide).find('.item-wrapper').attr('id');
		if (typeof currentSlide.dataset.fileUrl !== 'undefined') {
			var url = currentSlide.dataset.fileUrl,
				name = currentSlide.dataset.fileName;
			loadPdf(id, name, encodeURI(url));
		}
		window.slick = slick
	});
	// On before slide change
	$('.hpslider-for').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		var slide = slick.$slides.get(nextSlide);
		var id = $(slide).find('.item-wrapper').attr('id');
		if (id && typeof slide.dataset.fileUrl !== 'undefined') {
			var url = encodeURI(slide.dataset.fileUrl),
				name = slide.dataset.fileName;
			loadPdf(id, name, url);
		}
	});
	function loadPdf(divId = "hp-pdf-slide", name, url) {
		url = url.replaceAll("%2520", "%20");
		// console.log(url)
		let adobeClientId = "";
		let domain = window.location.hostname;

		if (domain.includes("hillphoenix.com")) {
			adobeClientId = "aeaa1e5db47648f1a4b0b3358906f89e";
		} else if(domain.includes("hillphoenixindustrial.com")) {
			adobeClientId = "8cab35ca7c8a420ea5e0005a89ba284d";
		}else{
			adobeClientId = "69620882ebdb4279a1ab7db1ec052299";//"8570dda0d983451fbcbd70cd5fb3e28b";
		}


		if (typeof AdobeDC !== 'undefined') {
			var adobeDCView = new AdobeDC.View({ clientId: adobeClientId, divId: divId });
			adobeDCView.previewFile(
				{
					content: { location: { url: url } },
					metaData: { fileName: name }
				}, { showAnnotationTools: false });
		} else {
			document.addEventListener("adobe_dc_view_sdk.ready", function () {
				var adobeDCView = new AdobeDC.View({ clientId: adobeClientId, divId: divId });
				adobeDCView.previewFile(
					{
						content: { location: { url: url } },
						metaData: { fileName: name }
					}, { showAnnotationTools: false });
			});
		}
	}
})(jQuery);

function getCurrentQuery() {
	var query;
	var currentPath = window.location.pathname.replaceAll('/', '');
	if (currentPath.trim().toString() === hillphoenixJs.home.trim().toString()) {
		query = getCookie('hp_main_query')
	} else {
		query = getCookie('hp_query')
	}
	if (query.length) {
		query = JSON.parse(query);
		if (Object.keys(query).length) {
			return query;
		}
	}
	return null;
}

function setCookie(cname, cvalue, exdays, path) {
	localStorage.setItem(cname, cvalue);
	// var d = new Date();
	// path = path || '/'
	// d.setTime(d.getTime() + (exdays*24*60*60*1000));
	// var expires = "expires="+ d.toUTCString();
	// //var expires = "Max-Age=0";
	// document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+path;
}

function getCookie(cname) {
	var dataItems = localStorage.getItem(cname);
	if (dataItems) {
		return dataItems;
	}
	return '';
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}